/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import './styles/Step02.css'

/**
 *     Import
 *     - Components
 */
import { Alert } from '../../../../../common/Alert/Alert'
import Loading from '../../../../../common/Loading/Loading'
import AddressBlock from './components/AddressBlock'
import { PlusIcon } from '../../../../../../images/icons/Plus/Plus'
import { Button } from '../../../../../common/Button/Button'
import PopUp from '../../../../../common/PopUp/PopUp'
export default class Step02cp extends React.Component<any, any> {

    checkAtLeastOneVerified = false

    constructor(props: any) {
        super(props)
        this.state = {
            newAddressBlock: false,
            securityVerifiedBlock: false,
            showPopup: false,
        }
    }

    componentDidMount() {
        if (!this.props.mta) {
            if (this.props.editRenewal && this.props.renewalQuoteId) {
                this.props.fetchLocations(this.props.renewalQuoteId)
            } else {
                this.props.fetchLocations(this.props.match.params.id)
            }
        }
        this.props.fetchCountries()
    }

    componentWillReceiveProps(nextProps: any) {
        if (!this.props.mta && !nextProps.riskLocations.done && !nextProps.riskLocations.loading) {
            if (this.props.editRenewal && this.props.renewalQuoteId) {
                this.props.fetchLocations(this.props.renewalQuoteId)
            } else {
                this.props.fetchLocations(this.props.match.params.id)
            }
        }
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Step02cpFormHTML
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    /**
     * Toggle the new address block
     * Or set if newState is set
     */
    toggleAddNewAddressBlock = (newState: any = !this.state.newAddressBlock) => {
        this.setState({ newAddressBlock: newState, securityVerifiedBlock: false })
        if (!this.props.editQuote && this.props.updateDirty) this.props.updateDirty(newState)
    }

    /**
     * Trigger action to create new address
     * Close open block setting state.newAddressBlock
     */
    createNewAddress = (address: any) => {
        if (this.props.editRenewal && this.props.renewalQuoteId) {
            // this.props.addLocationsRenewals(this.props.renewalQuoteId, address)
            this.props.addLocations(this.props.renewalQuoteId, address)
            this.props.getRenewalVariation(this.props.renewalQuoteId)
            this.props.step02Update()
        } else {
            this.props.addLocations(this.props.match.params.id, address)
        }
        this.setState({ newAddressBlock: false, securityVerifiedBlock: false })
        if (this.props.updateDirty) this.props.updateDirty(true)
    }

    /**
     * Trigger popup to confirm delete address
     */
    deleteLocation = (id: number) => {
        this.setState({ showPopup: id })
    }

    /**
     * Manage the OK response on the popup
     */
    deleteLocationConfirm = (id: number) => {
        // this.props.deleteLocation(this.props.match.params.id, id)
        // this.setState({ showPopup: false })
        if (this.props.editRenewal && this.props.renewalQuoteId) {
            this.props.deleteLocation(this.props.renewalQuoteId, id)
            this.props.getRenewalVariation(this.props.renewalQuoteId)
        } else {
            this.props.deleteLocation(this.props.match.params.id, id)
        }
        this.setState({ showPopup: false })
        if (this.props.updateDirty) this.props.updateDirty(true)
    }

    /**
     * Close the popup
     */
    closePopup = () => this.setState({ showPopup: false })

    /**
     * Handle the cancel action on address blocks
     */
    handleCancel = () => this.setState({ newAddressBlock: false })

    /**
     * Handle the cancel action on address blocks
     */
    handleSubmit = () => {
        this.props.submitStep02(this.props.match.params.id)
        this.props.history.push(`/quote/${this.props.match.params.id}/step05`)
    }

    getCountry = (countryid: any) => {
        const {
            countries,
        } = this.props
        let myCountry = countries.data.find(e => e.id === countryid)
        return myCountry.name
    }

    moveBack = () => {
        this.props.history.push(`/quote/${this.props.match.params.id}/step01`)
    }

    updateStep02 = () => {
        if (this.props.editQuote) {
            this.props.update()
        }
    }

    render() {
        // console.log(this.props.renewalQuoteId)
        const {
            riskLocations,
            checkStep,
            countries,
            fetchOccupancies,
            occupancies,
            editQuote,
        } = this.props

        if (!checkStep.done && !this.props.editRenewal && !this.props.editQuote) {
            return null
        }
        const isCollectors = (this.props.editRenewal || this.props.editQuote) ?
            this.props.isCollectors : checkStep.response.isCollectors
        const isMuseums = (this.props.editRenewal || this.props.editQuote) ?
            this.props.isMuseums : checkStep.response.isMuseums
        const isDealersStock = (this.props.editRenewal || this.props.editQuote) ?
            this.props.isDealersStock : checkStep.response.isDealersStock
        const isWineSpirits = (this.props.editRenewal || this.props.editQuote) ?
            this.props.isWineSpirits : checkStep.response.isWineSpirits
        const isCommercialProperty = (this.props.editRenewal || this.props.editQuote) ?
            this.props.isCommercialProperty : checkStep.response.isCommercialProperty
        let errorList: any[] = []
        let errorState: any = null // Fake errorState for test proposes
        if (errorState !== null) { errorList.push(errorState._data) }

        /**
         * *** WIP ***
         * To prevent errors on loading trigger loading component
         */
        if (riskLocations.loading) {
            return (<div className="step02"><Loading /></div>)
        }

        let securedIndex = riskLocations.response.findIndex(
            // Check if there's at least one Address checked
            // if yes set 'Save and Continue' button active
            r => r.securityVerified === false
        )
        if (securedIndex !== -1) {
            this.checkAtLeastOneVerified = true
        } else {
            this.checkAtLeastOneVerified = false
        }
        const quoteId = this.props.editRenewal ?
            parseInt(this.props.renewalQuoteId, 10) : parseInt(this.props.match.params.id, 10)
        return (
            <div
                className={`step02 quote__form ${isCollectors ? 'collectors' : isMuseums ? 'Museums' : isDealersStock ?
                    'dealers-strock' : 'commercial-art'}
                ${this.state.newAddressBlock ? 'step02--newAddress' : ''}
            ${this.state.securityVerifiedBlock ? 'step02--securityVerified' : ''}`}
            >

                {(errorList.length) ? (
                    <Alert type="error">
                        {errorList.map((a, i) => (<p key={i}>{a}</p>))}
                    </Alert>
                ) : null}

                {this.state.showPopup ? (
                    <PopUp
                        title={'Remove address'}
                        action={() => this.deleteLocationConfirm(this.state.showPopup)}
                        buttonText={'Remove'}
                        numberButtons={2}
                        secondaryAction={this.closePopup}
                        secondaryButtonText={'Cancel'}
                        overlay={true}
                    >
                        Do you really want to remove this address?
                    </PopUp>
                ) : null}

                <div className={`step02__container ${editQuote ? 'edit_02_container' : ''}`}>
                    <div className="addressBlock__outer">

                        {!this.state.newAddressBlock && riskLocations.response.map((r, i) => {
                            return (
                                <AddressBlock
                                    {...this.props}
                                    key={i}
                                    id={r.id}
                                    quoteId={quoteId}
                                    addressType={r.addressType}
                                    addressLine1={(r.addressLine1) ? r.addressLine1 :
                                        (this.props.mta) ? (r.addressType === 'museum') ? r.museum : r.storageLocation :
                                            null}
                                    addressLine2={(r.addressLine2) ? r.addressLine2 : null}
                                    city={r.city}
                                    postcode={r.postcode}
                                    securityVerified={
                                        (this.props.mta &&
                                            (r.addressType === 'storage location' || r.addressType === 'retail location'
                                                || r.addressType === 'office' || r.addressType === 'museum' ||
                                                r.addressType === 'storage')
                                        ) ? true : r.securityVerified}
                                    addLocationsSecurity={this.props.addLocationsSecurity}
                                    deleteLocation={this.props.deleteLocation}
                                    hideDeleteLocation={(riskLocations.response.length === 1) ? true : false}
                                    handleCancel={this.toggleAddNewAddressBlock}
                                    openedNewAddress={() => this.setState({ securityVerifiedBlock: true })}
                                    updateDirty={() => this.updateStep02()}
                                    getLatLongTrigger={this.props.getLatLong}
                                    isCollectors={isCollectors}
                                    isMuseums={isMuseums}
                                    isDealersStock={isDealersStock}
                                    isWineSpirits={isWineSpirits}
                                    isCommercialProperty={isCommercialProperty}
                                    countries={countries.data}
                                    countryName={(checkStep.response.isCollectors || checkStep.response.isWineSpirits) ?
                                        (r.countryName && !r.countryId) ?
                                            r.countryName : this.getCountry(r.countryId) :
                                        (checkStep.response.isMuseums || checkStep.response.isDealersStock) ?
                                            (r.countryName && !r.countryId) ?
                                                r.countryName : this.getCountry(r.countryId) : null}
                                    fetchOccupancies={fetchOccupancies}
                                    occupancies={occupancies}
                                    propertyData={r}
                                    temp_id={r.temp_id}
                                    initial_address={r.initial_address}
                                >
                                    {r.addressType}
                                </AddressBlock>
                            )
                        })}

                        {(!this.state.newAddressBlock && !this.state.securityVerifiedBlock) &&
                            <div className="addAddressWrap">
                                <div className="addAddress" onClick={this.toggleAddNewAddressBlock}>
                                    <div>
                                        <PlusIcon /><span>Add another risk address</span><PlusIcon />
                                    </div>
                                </div>
                            </div>
                        }

                    </div>
                </div>

                {this.state.newAddressBlock &&
                    <AddressBlock
                        newAddress={true}
                        handleCancel={this.toggleAddNewAddressBlock}
                        createNewAddress={this.createNewAddress}
                        updateDirty={(state) => { if (this.props.updateDirty) this.props.updateDirty(state) }}
                        openedNewAddress={() => this.setState({ securityVerifiedBlock: true })}
                        getLatLongTrigger={this.props.getLatLong}
                        isCollectors={isCollectors}
                        isMuseums={isMuseums}
                        isDealersStock={isDealersStock}
                        isWineSpirits={isWineSpirits}
                        isCommercialProperty={isCommercialProperty}
                        countries={countries.data}
                        mta={this.props.mta}
                        editQuote={this.props.editQuote}
                        fetchOccupancies={fetchOccupancies}
                        occupancies={occupancies}
                    />
                }

                {(!this.props.mta && !this.props.editQuote) ?
                    <div className="quote__form__group quote__form__group--submit">
                        {(isCollectors || isMuseums || isDealersStock || isWineSpirits) &&
                            <Button
                                half={true}
                                type="button"
                                onClick={this.moveBack}
                            >
                                Back
                            </Button>
                        }
                        <Button
                            type="submit"
                            onClick={this.handleSubmit}
                            disabled={!this.checkAtLeastOneVerified &&
                                !this.state.securityVerifiedBlock && riskLocations.response.length > 0 ? false : true}
                            half={(isCollectors || isMuseums || isDealersStock || isWineSpirits) ? true : false}
                        >
                            Save and continue
                        </Button>
                    </div>
                    : null
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/Step02cp/Step02cp.tsx